module.exports = __webpack_public_path__ + "img/lady_chart.a3f745c2.svg";